import { MapLayer } from '../../layers/components/MapLayer'
import { useDrawRoadSegment } from './useDrawRoadSegment'

export function DrawRoadSegment() {
  useDrawRoadSegment()

  return <MapLayer uid="draw" />
}
